const handleAccordion = () => {
  const accordionItems = [...document.querySelectorAll('.accordion-item')];
  const itemsDims = [];

  accordionItems.forEach((item) => {
    const itemHeight = item.clientHeight;
    const titleElem = item.querySelector('.accordion-item-title');
    const arrow = item.querySelector('.accordion-line');
    const btn = item.querySelector('.accordion-btn');
    const btnClassToggle = 'active';
    const descHeight = itemHeight - titleElem.clientHeight;

    itemsDims.push({
      itemHeight,
      titleHeight: titleElem.clientHeight,
      descHeight,
    });

    item.style.height = `${itemHeight - descHeight}px`;

    item.addEventListener('click', function () {
      if (this.style.height === `${itemHeight - descHeight}px`) {
        // closingAllaccordionItems
        accordionItems.forEach((item, index) => {
          const { itemHeight: savedItemHeight, descHeight: savedDescHeight } =
            itemsDims[index];

          const arrow = item.querySelector('.accordion-line');
          const btn = item.querySelector('.accordion-btn');
          item.style.height = `${savedItemHeight - savedDescHeight}px`;
          arrow.style.opacity = 1;
          btn.classList.remove(btnClassToggle);
        });
        arrow.style.opacity = 0;
        btn.classList.add(btnClassToggle);
        this.style.height = `${itemHeight}px`;
      } else {
        this.style.height = `${itemHeight - descHeight}px`;
        arrow.style.opacity = 1;
        btn.classList.remove(btnClassToggle);
      }
    });
  });
};

export default handleAccordion;
